import { Text } from "@radix-ui/themes";

import { WORKFLOW_CARDS } from "../mockData";

interface WorkflowCardsProps {
  onCardClick: (workflowType: string) => void;
}

export function WorkflowCards({ onCardClick }: WorkflowCardsProps) {
  return (
    <div className="grid grid-cols-4 gap-2.5">
      {WORKFLOW_CARDS.map((card) => (
        <button
          key={card.id}
          data-testid={`ask-puntt-workflow-card-${card.workflowType}`}
          onClick={() => onCardClick(card.workflowType)}
          className="flex flex-col gap-1 rounded-lg border border-puntt-neutral-gray-6 bg-puntt-neutral-gray-2 p-3 text-left transition-all hover:border-puntt-neutral-gray-8 hover:shadow-sm"
        >
          <Text size="2" weight="bold" className="text-puntt-neutral-gray-12">
            {card.title}
          </Text>
          <Text size="1" className="text-puntt-neutral-gray-11">
            {card.description}
          </Text>
        </button>
      ))}
    </div>
  );
}
